<template>

<div class="nested" v-if="(item && item.game && item.game.contains && item.game.contains.length)" :class="{'is-active': is.active}">

    <app-view-list-item 
        :is-condensed="true" 
        :is-sticky="isSticky" 
        :item="subitem" 
        :fields="fields"
        :filter="filter"
        :grid="grid"
        :key="subitem.id" 
        v-for="subitem in contained" 
    >

		<div class="nested-horizontal" v-if="!isSticky"></div>

	</app-view-list-item>

	<div class="nested-vertical" v-if="!isSticky"></div>

</div>

</template>

<script>

export default {

	props: ['item', 'fields', 'grid', 'filter', 'isSticky'],

	data: function() {

		return {
			is: {
				active: false
			},
			can: {
				rename: false,
				tag: false,
				filter: false,
				nesting: false,
				export: false,
				game: true,
				list: {
					remove: false
				},
				users: {
					remove: false
				}
			},
			handler: {
				toggle: null
			}
		}

	},

	computed: {

		contained: function() {

			var contained = []

			if (!this.item || !this.item.game || !this.item.game.contains) return contained

			var map = this.$store.getters['page/' + this.$store.getters['service/select/name'] + '/contained/associated/collection'] || {}

			this.$_.each(this.item.game.contains, function(id) {

				if (id !== this.item.id) {

					var item = map[id]

					if (item && item.game) contained.push(item)

				}

			}.bind(this))

			contained = this.$_.sortBy(contained, function(item) {

				return (item && item.game && item.game.name) ? item.game.name : ''

			})

			return contained

		}

	},

	created: function() {

		this.handler.toggle = this.onToggle.bind(this)

		this.$pubsub.$on('contained.open.' + this.item.id, this.handler.toggle)

		this.is.active = this.$store.getters['data/stashed'](['contained', this.item.id], false)

	},

	beforeDestroy: function() {

		if (this.handler.toggle) {

			this.$pubsub.$off('contained.open.' + this.item.id, this.handler.toggle)

		}
		
	},

	methods: {

		onToggle: function() {

			this.is.active = !this.is.active

			this.$store.commit('data/stash', {
				name: ['contained', this.item.id],
				value: this.is.active
			})

		}

	}

}

</script>

<style scoped>

.nested {
	padding-bottom: 3px;
	margin-top: -4px;
	display: none;
}

.nested.is-active {
	display: block;
}

.nested-horizontal {
	position: absolute;
	height: 1px;
	width: 16px;
	left: 8px;
	top: 16px;
	border-bottom: 1px dotted #ccc;
}

.nested-vertical {
	position: absolute;
	border-left: 1px dotted #ccc;
	top: -4px;
	bottom: 20px;
	left: 8px;
	width: 1px;
}

.is-mobile .nested-vertical {
}

</style>
